<template>
  <div class="talleres-anual-page">
    <div class="container">

      <!-- Header -->
      <div class="anual-header">
        <h1 class="anual-title">Taller Anual</h1>
        <p class="anual-subtitle">Formación teatral continua con Grupo Babilonia</p>
      </div>

      <!-- Schedule -->
      <div class="schedule-section">
        <h2 class="schedule-title">Horarios</h2>

        <div class="schedule-grid">

          <div class="schedule-card">
            <div class="day-name">Lunes</div>
            <div class="day-time">19:00 - 22:00</div>
          </div>

          <div class="schedule-card">
            <div class="day-name">Martes</div>
            <div class="day-time">19:00 - 22:00</div>
          </div>

          <div class="schedule-card">
            <div class="day-name">Miércoles</div>
            <div class="day-time">19:00 - 22:00</div>
          </div>

          <div class="schedule-card schedule-kids">
            <div class="kids-badge">Para niños</div>
            <div class="day-name">Jueves</div>
            <div class="day-time">19:00 - 22:00</div>
          </div>

        </div>
      </div>

      <!-- Contact CTA -->
      <div class="contact-cta">
        <p class="contact-text">¿Querés sumarte? Escribinos para más información</p>
        <a href="https://wa.me/59899409402" target="_blank" rel="noopener" class="contact-btn">
          <span class="whatsapp-icon">📱</span>
          Contactanos
        </a>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'TalleresAnualPage'
}
</script>

<style scoped>
.talleres-anual-page {
  background: #000;
  padding: 60px 0 80px;
  min-height: 50vh;
}

.container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 20px;
}

/* Header */
.anual-header {
  text-align: center;
  margin-bottom: 50px;
}

.anual-title {
  font-size: 42px;
  font-weight: bold;
  color: #fff;
  margin: 0 0 15px 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.anual-subtitle {
  font-size: 18px;
  color: #aaa;
  margin: 0;
  font-style: italic;
}

/* Schedule Section */
.schedule-section {
  margin-bottom: 50px;
}

.schedule-title {
  font-size: 24px;
  font-weight: bold;
  color: #c9a227;
  text-align: center;
  margin: 0 0 30px 0;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}

.schedule-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}

.schedule-card {
  position: relative;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid #333;
  border-radius: 10px;
  padding: 30px 25px;
  text-align: center;
  transition: all 0.3s ease;
}

.schedule-card:hover {
  border-color: #c9a227;
  background: rgba(201, 162, 39, 0.05);
  transform: translateY(-3px);
}

.schedule-kids {
  background: rgba(201, 162, 39, 0.1);
  border-color: #c9a227;
}

.kids-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #c9a227;
  color: #000;
  font-size: 12px;
  font-weight: bold;
  padding: 5px 15px;
  border-radius: 20px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.day-name {
  font-size: 28px;
  font-weight: bold;
  color: #fff;
  margin-bottom: 10px;
}

.day-time {
  font-size: 20px;
  color: #c9a227;
  font-weight: 500;
}

/* Contact CTA */
.contact-cta {
  background: linear-gradient(135deg, #1a1a1a 0%, #0d0d0d 100%);
  border: 1px solid #333;
  padding: 40px;
  border-radius: 10px;
  text-align: center;
}

.contact-text {
  font-size: 18px;
  color: #ddd;
  margin: 0 0 25px 0;
}

.contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: #c9a227;
  color: #000;
  font-size: 18px;
  font-weight: bold;
  text-decoration: none;
  padding: 15px 35px;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background: #d4af37;
  transform: scale(1.05);
}

.whatsapp-icon {
  font-size: 22px;
}

/* Mobile */
@media (max-width: 767px) {
  .talleres-anual-page {
    padding: 40px 0 60px;
  }

  .anual-title {
    font-size: 28px;
  }

  .anual-subtitle {
    font-size: 16px;
  }

  .schedule-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }

  .schedule-card {
    padding: 25px 20px;
  }

  .day-name {
    font-size: 24px;
  }

  .day-time {
    font-size: 18px;
  }

  .contact-cta {
    padding: 30px 20px;
  }

  .contact-text {
    font-size: 16px;
  }

  .contact-btn {
    font-size: 16px;
    padding: 12px 25px;
  }
}
</style>